export const INFO_AVATAR = '/images/info.svg';
export const ERROR_AVATAR = '/images/error-warning.svg';
export const WARNING_AVATAR = '/images/warning.svg';

export const DEFAULT_AVATARS = Object.freeze([
  `/images/avatar.svg`,
  `/images/building.svg`,
  INFO_AVATAR,
  `/images/speaker.svg`,
  `/images/confetti.svg`,
  `/images/novu.svg`,
  `/images/info-2.svg`,
  `/images/bell.svg`,
  '/images/error.svg',
  WARNING_AVATAR,
  `/images/question.svg`,
  ERROR_AVATAR,
]);
